import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Field, reduxForm, reset, getFormValues } from 'redux-form';
import Recaptcha from 'react-google-invisible-recaptcha';

import TextField from '../TextField/TextField';
import Checkbox from '../Checkbox/Checkbox';

import * as validate from '../../utils/validate';
import { sendFeedback } from '../../services/apiClient';

import './FeedbackForm.scss';

class FeedbackForm extends Component {
  constructor() {
    super();

    this.validate = {
      name: [validate.required('validateRequire')],
      email: [validate.required('validateRequire'), validate.email('validateEmail')],
      phone: [validate.required('validateRequire')],
      privacy_policy: [validate.required('validateRequire')]
    };
  }

  onSubmit = () => {
    const { dispatch, formData } = this.props;
    const data = {
      ...formData,
      // 'g-recaptcha-response': recaptchaHash
    };

    sendFeedback(data)
      .then(() => {
        alert('Thanks you!');
        dispatch(reset('feedback-form'));
      })
      .catch(() => {
        alert('Something went wrong!');
      });
  }

  get privacyText() {
    const { langs } = window;

    return (
      <span className="form__checkbox-text">
        <span> { langs.privacyPoliticText } </span>
        <a href={ langs.privacyPoliticHref } rel="noopener noreferrer" target="_blank" className="form__checkbox-link"> { langs.privacyPoliticLinkText } </a>
      </span>
    )
  }

  render() {
    const { handleSubmit, currentLang } = this.props;
    const { langs } = window;

    return (
      <div className="feedback-form">
        <div className="feedback-form__title" dangerouslySetInnerHTML={{ __html: langs.feedbackFormTitle }}></div>
        <form className="form" onSubmit={ handleSubmit(this.onSubmit) } id="feedback-form">
          <div className="feedback-form__fields">
            <label className="form__field feedback-form__field">
              <Field type="text" component={ TextField } name="name" className="form__input" placeholder={ langs.feedbackFormName } validate={ this.validate.name } />
            </label>
            <label className="form__field feedback-form__field">
              <Field type="text" component={ TextField } name="email" className="form__input" placeholder={ langs.feedbackFormEmail } validate={ this.validate.email } />
            </label>
            <label className="form__field feedback-form__field">
              <Field type="text" component={ TextField } name="phone" className="form__input" placeholder={ langs.feedbackFormPhone } validate={ this.validate.phone } />
            </label>
          </div>
          <div className="feedback-form__textarea">
            <Field type="text" component="textarea" name="question" className="form__textarea" placeholder={ langs.feedbackFormQuestion } />
          </div>
          <div className="feedback-form__privacy">
            <Field name="privacy_policy" component={ Checkbox } validate={ this.validate.privacy_policy } text={ this.privacyText } />
          </div>
          <button form="feedback-form" className="form__btn feedback-form__btn">{ langs.feedbackFormSend }</button>
        </form>
      </div>
    )
  }
}

FeedbackForm = reduxForm({
  form: 'feedback-form'
})(FeedbackForm);

function mapStateToProps(state) {
  const { language } = state;

  return {
    formData: getFormValues('feedback-form')(state),
    currentLang: language.current
  };
}

export default connect(mapStateToProps)(FeedbackForm);



// WEBPACK FOOTER //
// ./src/components/FeedbackForm/FeedbackForm.js